<template>
  <div id="map" :class="{ 'fullMap': !normalMapSize }"></div>
</template>
<script>
  import GoogleMapsLoader from 'google-maps'
  import server_config from 'src/server_config.js'
  export default {

    data () {
      return {
        myMap: null,
        normalMapSize: true,
        allMarkers: {},
        focusedMarker: null,
        currentSignals: this.signals,
        lastCarLocationMarker: null,
        mainMarkerImg: 'http://maps.google.com/mapfiles/kml/paddle/red-square.png',
        markerImgCommon: 'http://maps.google.com/mapfiles/kml/paddle/wht-stars.png',
        markerImgPined: 'http://maps.google.com/mapfiles/kml/pushpin/wht-pushpin.png',
        lastLocation: 'http://maps.google.com/mapfiles/kml/paddle/grn-stars.png',
        mainMarker: new google.maps.Marker(),
      }
    },

    props: {
      lastCarLocation: null,
      signals: null,
      markerFocused: null,
      freshSignals: null
    },

    methods: {

      /**
       * @author Sandoval Lucas
       *
       * @description Modifica la variable que indica si la pantalla es
       * suficientemente grande para manejar el tamaño normal o debe usar tamaño completo
       */
      handleResize (event) {
        this.normalMapSize = (document.documentElement.clientWidth > 991) ? true : false
      },

      getLastPosition () {
        let lat
        let lng
        if (this.currentSignals.length === 0) {
          lat = -34.508657
          lng = -58.517124
        } else {
          lat = this.currentSignals[0].latitude
          lng = this.currentSignals[0].longitude
        }
        return new google.maps.LatLng(lat, lng)
      },

      getTimeDifference (event_timestamp) {
        var then = new Date(event_timestamp)
        var now = new Date()
        var difference = Math.trunc(Math.abs((now.getTime() - then.getTime()) / 1000))

        var hours = Math.trunc(difference / 3600)
        var minutes = Math.trunc((difference % 3600) / 60)
        var seconds = Math.trunc((difference % 3600) % 60)

        return `${hours} hora(s) ${minutes} minuto(s) ${seconds} segundo(s)`
      },

      focusMarker (id) {
        this.focusedMarker = id
        this.myMap.setCenter(this.allMarkers[id].getPosition())
        if (this.allMarkers[id] !== this.mainMarker) {
          google.maps.event.trigger(this.allMarkers[id], 'show-data')
        }
      },

      unfocusMarker () {
        if (this.allMarkers[this.focusedMarker] !== this.mainMarker) {
          google.maps.event.trigger(this.allMarkers[this.focusedMarker], 'hide-data')
        }
      },

      initMap (google) {
        var myLatlng = this.getLastPosition()
        var mapOptions = {
          zoom: 10,
          center: myLatlng,
          // mapTypeId: google.maps.MapTypeId.HYBRID, //satellite with labels
          // scrollwheel: false, // we disable de scroll over the map, it is a really annoing when you scroll through page
          gestureHandling: 'cooperative',
          styles: [{
            'featureType': 'water',
            'stylers': [{'saturation': 43}, {'lightness': -11}, {'hue': '#0088ff'}]
          }, {
            'featureType': 'road',
            'elementType': 'geometry.fill',
            'stylers': [{'hue': '#ff0000'}, {'saturation': -100}, {'lightness': 99}]
          }, {
            'featureType': 'road',
            'elementType': 'geometry.stroke',
            'stylers': [{'color': '#808080'}, {'lightness': 54}]
          }, {
            'featureType': 'landscape.man_made',
            'elementType': 'geometry.fill',
            'stylers': [{'color': '#ece2d9'}]
          }, {
            'featureType': 'poi.park',
            'elementType': 'geometry.fill',
            'stylers': [{'color': '#ccdca1'}]
          }, {
            'featureType': 'road',
            'elementType': 'labels.text.fill',
            'stylers': [{'color': '#767676'}]
          }, {
            'featureType': 'road',
            'elementType': 'labels.text.stroke',
            'stylers': [{'color': '#ffffff'}]
          }, {'featureType': 'poi', 'stylers': [{'visibility': 'off'}]}, {
            'featureType': 'landscape.natural',
            'elementType': 'geometry.fill',
            'stylers': [{'visibility': 'on'}, {'color': '#b8cb93'}]
          }, {'featureType': 'poi.park', 'stylers': [{'visibility': 'on'}]}, {
            'featureType': 'poi.sports_complex',
            'stylers': [{'visibility': 'on'}]
          }, {'featureType': 'poi.medical', 'stylers': [{'visibility': 'on'}]}, {
            'featureType': 'poi.business',
            'stylers': [{'visibility': 'simplified'}]
          }]

        }
        var map = new google.maps.Map(document.getElementById('map'), mapOptions)
        this.myMap = map

        this.setLastLocationMarker()

        this.currentSignals.map((element, index) => {
          var infoWindow = new google.maps.InfoWindow({
            content: this.getInfowindowText(element)
          });

          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(this.currentSignals[index].latitude, this.currentSignals[index].longitude),
            title: this.currentSignals[index].address,
            animation: google.maps.Animation.DROP,
            icon: this.lastLocation,
            map: null
          })
          //debugger;
          if (index === 0) {
            this.mainMarker = marker
            this.mainMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1)
            this.mainMarker.setMap(map)
            this.mainInfoWindow = infoWindow
            this.setListenerOpen(this.mainMarker, this.mainInfoWindow, 'show-data-main')
            this.setListenerClose(this.mainMarker, this.mainInfoWindow, 'hide-data-main')
            this.mainMarker.setIcon(this.mainMarkerImg)
            google.maps.event.trigger(this.mainMarker, 'show-data-main')
          } else {
            this.setCommonMarker(marker, infoWindow)
          }


          this.allMarkers[element.index] = marker

        })

      },

      agregateMarkers (signals) {
        signals.map( (element, index) => {
          if (! this.allMarkers.hasOwnProperty(element.index)) {

            var map = this.myMap

            var infoWindow = new google.maps.InfoWindow({
              content: this.getInfowindowText(element)
            });

            var marker = new google.maps.Marker({
              position: new google.maps.LatLng(signals[index].latitude, signals[index].longitude),
              title: signals[index].address,
              animation: google.maps.Animation.DROP,
              icon: this.markerImgCommon,
              map: null
            })

            if (index === 0) {

              google.maps.event.trigger(this.mainMarker, 'hide-data-main')
              this.mainMarker.setIcon(this.markerImgCommon)
              this.mainMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1)

              this.setCommonMarker(this.mainMarker, this.mainInfoWindow)

              this.mainMarker = marker
              this.mainMarker.setMap(map)
              this.mainInfoWindow = infoWindow
              this.setListenerOpen(this.mainMarker, infoWindow, 'show-data-main')
              this.setListenerClose(this.mainMarker, infoWindow, 'hide-data-main')
              this.mainMarker.setIcon(this.mainMarkerImg)
              google.maps.event.trigger(this.mainMarker, 'show-data-main')
            } else {
              this.setCommonMarker(marker, infoWindow)
            }

            this.allMarkers[element.index] = marker

          }

        })
      },

      setLastLocationMarker() {
        if (this.lastCarLocation != null && this.myMap != null) {
          const position = new google.maps.LatLng(this.lastCarLocation.location.latitude, this.lastCarLocation.location.longitude);
          this.lastCarLocationMarker = new google.maps.Marker({
            position,
            title: "Ultima ubicación",
            animation: google.maps.Animation.DROP,
            icon: this.lastLocation,
            map: this.myMap
          })
          if (this.signals == null || this.signals.length === 0) {
            this.myMap.panTo(position)
          }
        }
      },

      setCommonMarker (marker, infoWindow) {
        // this.setListenerOpen(marker, infoWindow, 'mouseover')
        // this.setListenerClose(marker, infoWindow, 'mouseout')
        this.setListenerOpen(marker, infoWindow, 'show-data', this.markerImgCommon)
        this.setListenerClose(marker, infoWindow, 'hide-data')
      },

      setListenerOpen (marker, infoWindow, event, icon=null) {
        marker.addListener(event, () => {
          if (marker !== this.mainMarker || (marker === this.mainMarker && event === 'show-data-main')) {
            infoWindow.open(this.myMap, marker)
            if (marker !== this.mainMarker) {
              marker.setMap(this.myMap)
            }
            if (icon !== null) {
              marker.setIcon(icon)
            }
          }
        })
      },

      setListenerClose (marker, infoWindow, event, icon=null) {
        marker.addListener(event, function () {
          if (marker !== this.mainMarker || (marker === this.mainMarker && event === 'hide-data-main')) {
            infoWindow.close(this.myMap, marker)
            if (marker !== this.mainMarker) {
              marker.setMap(null)
            }
            if (icon !== null) {
              marker.setIcon(icon)
            }
          }
        })
      },

      deleteMarkers (newSignals) {
        var keys = Object.keys(this.allMarkers)
        keys.map( key => {
          if (newSignals.every( signal => { signal.index !== key })) {
            this.allMarkers[key].setMap(null)
            delete this.allMarkers[key]
          }
        })

        // newSignals.map( element => {
        //   if (this.allMarkers.hasOwnProperty(element.index)){
        //     existent.push(element)
        //   }
        // })

        // Object.keys(this.allMarkers).map(element => {
        //   this.allMarkers[element].setMap(null)
        // })
        // this.allMarkers = {}
      },

      getInfowindowText(element) {
        return `
          <b>Dirección</b>: ${element.address}<br>
          <b>Fecha y hora</b>: ${element.datetime}<br>
          <b>Hace</b>: ${this.getTimeDifference(element.event_timestamp)}`
      }
    },

    mounted () {
      GoogleMapsLoader.KEY = server_config.key
      GoogleMapsLoader.load((google) => {
        this.initMap(google)
      })
      this.$nextTick( () => {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
      })
    },

    watch: {
      markerFocused: function (id) {
        this.unfocusMarker()
        this.focusMarker(id)
      },
      signals: function (val) {
        this.agregateMarkers(val)
        setTimeout(this.$forceUpdate, 500)
      },
      freshSignals: function (val) {
        //   ('Markers: ' + this.allMarkers.length)
        // this.agregateMarkers(val)
        this.deleteMarkers(val)
        this.agregateMarkers(val)
        setTimeout(this.$forceUpdate, 500)
      },
      lastCarLocation: function (val) {
        if (this.lastCarLocationMarker != null && this.myMap != null) {
          this.lastCarLocationMarker.setMap(null)
        }
        if (val != null) {
          this.setLastLocationMarker();
        }
      }
    },

    // Metodos exclusivos para manejar el resize de la pagina y adaptar el mapa a la misma
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    }
  }

</script>
<style>

#map {
  height: 400px;
  overflow: hidden;
  padding-bottom: 22.25%;
  padding-top: 30px;
  position: relative;
}

.fullMap {
  width: 100%
}

</style>



// WEBPACK FOOTER //
// Maps.vue?34ac2604